module.exports = __webpack_public_path__ + "quote1.761089fdc7c2c7524920.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Home/OneDrive/Documents/hotellife_web/src/assets/images/quote1.svg
// module id = ../../../../../src/assets/images/quote1.svg
// module chunks = styles